<template>
    <CheckboxGroup
      :value="value"
      :options="statuses"
      :disabled="disabled"
      :show-confetti="showConfetti"
      @input="input"
      @complete="completeAnimation"
    />
</template>

<script>
  import { ISSUE_STATUS } from '@/_legacy/constants';
  import CheckboxGroup from '@/_legacy/components/CheckboxGroup.vue';

  export default {
    name: 'StatusSelector',
    components: {
      CheckboxGroup,
    },
    props: {
      value: {
        type: Number,
        default: 0,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        showConfetti: false
      };
    },
    computed: {
      statuses() {
        return [
          {
            key: ISSUE_STATUS.OPEN,
            value: this.$t('status.pending'),
            status: 'bg-blue',
          },
          {
            key: ISSUE_STATUS.IN_PROGRESS,
            value: this.$t('Started'),
            status: 'bg-yellow',
          },
          {
            key: ISSUE_STATUS.SOLVED,
            value: this.$t('Done'),
            status: 'bg-green',
            hasConfetti: true
          },
          {
            key: ISSUE_STATUS.CANT_DO,
            value: this.$t('status.cant-do'),
            status: 'bg-60',
          },
        ];
      },
    },
    methods: {
      input(value) {
        this.$emit('input', value);
        this.showConfetti = value === ISSUE_STATUS.SOLVED && this.value !== value;
      },
      completeAnimation() {
        this.showConfetti = false;
      }
    },
  };
</script>
